import Flickity from 'flickity';

export default class HeroComponent {

  constructor(options) {

    this.name = options.elem;
    this.elem = $(options.elem);

    // defaults
    this.options = {};
    this.options.mousemove = false;
    this.options.animateText = true;
    this.options.parallaxCopy = false;

    // overrride the deafults
    $.extend(this.options, options);

    if ( this.elem.length === 0 ) {
      console.error( `Hero Component Error: element '${this.options.elem}' not found` );
      return;
    }

    // mouse move feature vars
    this.mX = 0;
    this.mY = 0;
    this.mousedOver = false;

    // animating the text vars
    this.animateTextTrigger = false;

    // promos modifier vars
    this.hasPromoSlider = false;
    this.showPromoSlider = false;

    // parallax copy modifier
    this.elemIsOnScreen = false;
    this.tY = 0;
    this.tO = 0;

    // scroll offset vars
    this.sTop = $(window).scrollTop();
    this.sLeft = $(window).scrollLeft();

    // enable the mouse parallax
    if (this.options.mousemove) {
      this.enableMouseMove();
    }

    if (this.options.animateText && !this.options.parallaxCopy) {
      this.handleScroll();
    }

    if (this.elem.find('.cmpnt__hero_points').length > 0 ) {
      this.hasPromoSlider = true;
      this.setupPromoSlider();
    }

    if (this.options.parallaxCopy) {
      this.enableParallaxCopy();
    }


    // track the scroll position
    $(window).scroll( e => this.handleScroll(e) );
    $(window).resize( e => this.handleResize(e) );

  }

  setupParallaxCopy() {

    // PARALLAX'D COPY ONLY WORKS FOR THE HEADER COMPONENT.. WORK ON THIS CODE IF YOU NEED IT FOR ALL

    this.setupParallaxHeader();

    /* const vpt = 0;
    const vpb = $(window).height();
    const st = $(window).scrollTop();
    const travelY = -100;

    if ( this.elem.offset().top - st < vpb && ( this.elem.height() + this.elem.offset().top ) - st > vpt ) {
      const vpc = -(this.elem.offset().top - st - vpb);
      const vpmax = this.elem.height() + vpb;
      const vpp = ( vpc / vpmax );

      this.tY = ( travelY * vpp ) - (travelY / 2);
      this.tO = 1;

      if ( vpp < 0.49 ) {
        this.tO = (vpp / 0.49) * 1;
      } else if ( vpp > 0.51 ) {
        this.tO = ( (1 - vpp) / 0.49) * 1;
      }

      if ( this.tO > 1 ) { this.tO = 1; }

      if ( st === 0 ) {
        this.tO = 1;
        this.tY = 0;
      }

      this.elemIsOnScreen = true;
      this.updateUI();

      // console.log(st, vpp);

      // console.log(this.name, ' IS ON SCREEN');
    } else {
      this.elemIsOnScreen = false;
      // console.log(this.name, ' IS OFF SCREEN');
    } */


  }

  setupParallaxHeader() {
    const st = $(window).scrollTop();
    const travelY = -20;

    if ( st < this.elem.height() ) {

      const percent = 1 - ( st / this.elem.height() );

      this.tY = travelY - ( travelY * percent );
      this.tO = ( 1 * percent );

      if ( $(window).height() < 550 ) {
        this.tY = 0;
        this.tO = 1;
      }

      this.elemIsOnScreen = true;
      this.updateUI();

    } else {
      this.elemIsOnScreen = false;
      // console.log(this.name, ' IS OFF SCREEN');
    }
  }

  setupPromoSlider() {
    // only show the promos as a slider for phones/tabs
    if ( $(window).width() < 769 && !this.showPromoSlider ) {
      this.showPromoSlider = true;
      this.flkty = new Flickity( 'ul.cmpnt__hero_points', {
        cellAlign: 'center',
        prevNextButtons: false,
        wrapAround: true,
      });
    } else if ($(window).width() >= 769 && this.showPromoSlider) {
      this.flkty.destroy();
      delete this.flkty;
      this.showPromoSlider = false;
    }

  }


  setupInputParallax() {

    this.elem.mousemove( (e) => {
      this.mX = ( 0.5 * ( e.pageX / this.elem.outerWidth() ) ) - 0.25;
      this.mY = ( 0.5 * ( e.pageY / this.elem.outerHeight() ) ) - 0.25;
    } );

    this.elem.mouseover( () => {
      this.mousedOver = true;
      window.requestAnimationFrame( () => { this.updateUI(); } );
    } );

    this.elem.mouseout( () => {
      this.mousedOver = false;
    } );

  }

  setupTextAnimation() {

    const trigger = $(window).height() * 0.65; // 45% from the top of the viewport

    if ( this.elem.offset().top - this.sTop <= trigger ) {
      this.animateTextTrigger = true;
      this.updateUI();
    }

  }

  enableMouseMove() {
    this.options.mousemove = true;
    this.setupInputParallax();
  }

  enableParallaxCopy() {
    this.options.parallaxCopy = true;
    this.setupParallaxCopy();
  }

  // setup the UI render loop for all elements within the component
  updateUI() {
    if ( this.options.mousemove && this.mousedOver ) {
      window.requestAnimationFrame( () => {
        this.updateUI();
      });
      this.elem.children('div.cmpnt__hero__bg').css('transform', `translate(${this.mX}%, ${this.mY}% )`);
    }

    if ( this.options.animateText && this.animateTextTrigger && !this.elem.hasClass('is-aniActive') ) {
      this.elem.addClass('is-aniActive');
    }

   // console.log(this.options.parallaxCopy, this.elemIsOnScreen, this.tY, this.t0);
    if (this.options.parallaxCopy && this.elemIsOnScreen ) {
      this.elem.find('div.cmpnt__hero__copy').css('transform', `translateY(${this.tY}% )`);
      this.elem.find('div.cmpnt__hero__copy').css('opacity', this.tO);
    }
  }


  // window events
  handleResize() {
    if ( this.hasPromoSlider ) {
      this.setupPromoSlider();
    }
  }

  handleScroll() {

    this.sTop = $(window).scrollTop();
    this.sLeft = $(window).scrollLeft();

    if ( this.options.animateText && !this.options.parallaxCopy ) {
      this.setupTextAnimation();
    }

    if ( this.options.parallaxCopy ) {
      this.setupParallaxCopy();
    }

  }

}




// WEBPACK FOOTER //
// ./js/controllers/components/hero.js